import "../../styles/all.css"
import "../../styles/theme.css"
import personone from "../../img/p1.png"
import persontwo from "../../img/p2.png"
import personthree from "../../img/p3.png"
import personfour from "../../img/p4.png"
import personfive from "../../img/p5.png"
import personsix from "../../img/p6.png"
import "./leads.css"
function Leads(){
    return(
        <>
        <div className="leads">
           
              <div className="table">
                 <div className="form">
                <select name="" id="">
                    <option value="10">10</option>
                    <option value="10">40</option>
                    <option value="10">70</option>
                    <option value="10">90</option>

                </select>
                <input type="text" placeholder="Search Here" name="" id="" />
            </div>
                      
                       <div className="end">
                           <table className="table table-hover  rounded align-middle">
               <thead> 
                 <tr>
                    <th>Select User</th>
                   <th>Leads</th>
                         <th>Email</th>
           
                   <th>Source </th>
                   <th>Phone</th>
                   <th>Date</th>
                   <th>Status</th>
                 </tr>
               </thead>
             <tbody>
  <tr>
    <td>
        <input type="checkbox" name="" id="" />
    </td>
    <td>
      <img src={personone} alt="" />
    </td>
    <td>
      <p>Archie Cantones</p>
      <p>ariceh.tones@gmail.com</p>
    </td>
    <td><i class="fa-brands fa-facebook"></i>Facebook</td>
    <td>(375) 9632 549</td>
    <td>Completed</td>
    <td>
      <i className="fa-solid fa-ellipsis-vertical"></i>
    </td>
  </tr>

  <tr>
     <td>
        <input type="checkbox" name="" id="" />
    </td>
    <td>
      <img src={persontwo} alt="" />
    </td>
    <td>
      <p>Holmes Cherryman</p>
      <p>cherryman@gmail.com</p>
    </td>
    <td><i class="fa-brands fa-instagram"></i>Instgram</td>
    <td>(123) 9631 249</td>
    <td>In Progress</td>
    <td>
      <i className="fa-solid fa-ellipsis-vertical"></i>
    </td>
  </tr>

  <tr>
     <td>
        <input type="checkbox" name="" id="" />
    </td>
    <td>
      <img src={personthree} alt="" />
    </td>
    <td>
      <p>Malanie Hanvey</p>
      <p>malan-hanvey@gmail.com</p>
    </td>
    <td><i class="fa-brands fa-twitter"></i>Twiter</td>
    <td>(761) 9632 900</td>
    <td>Completed</td>
    <td>
      <i className="fa-solid fa-ellipsis-vertical"></i>
    </td>
  </tr>

  <tr>
     <td>
        <input type="checkbox" name="" id="" />
    </td>
    <td>
      <img src={personfour} alt="" />
    </td>
    <td>
      <p>Kenneth Hune</p>
      <p>nneth.une@gmail.com</p>
    </td>
    <td><i class="fa-brands fa-instagram"></i>Instgram</td>
    <td>(258) 9514 519</td>
    <td>Not Interested</td>
    <td>
      <i className="fa-solid fa-ellipsis-vertical"></i>
    </td>
  </tr>

  <tr>
     <td>
        <input type="checkbox" name="" id="" />
    </td>
    <td>
      <img src={personfive} alt="" />
    </td>
    <td>
      <p>Kennth Hune</p>
      <p>kennth.hune@gmail.com</p>
    </td>
    <td><i class="fa-brands fa-linkedin"></i>Linkedin</td>
    <td>(221) 9631 449</td>
    <td>Completed</td>
    <td>
      <i className="fa-solid fa-ellipsis-vertical"></i>
    </td>
  </tr>

  <tr>
     <td>
        <input type="checkbox" name="" id="" />
    </td>
    <td>
      <img src={personone} alt="" />
    </td>
    <td>
      <p>Sarah Johnson</p>
      <p>sarah.j@gmail.com</p>
    </td>
    <td><i class="fa-brands fa-facebook"></i>Facebook</td>
    <td>(322) 9000 5149</td>
    <td>In Progress</td>
    <td>
      <i className="fa-solid fa-ellipsis-vertical"></i>
    </td>
  </tr>
  <tr>
  <td><input type="checkbox" name="" id="" /></td>
  <td><img src={personfive} alt="" /></td>
  <td>
    <p> Youssed  Mohamed</p>
    <p>youssef.mohamed.92@gmail.com</p>
  </td>
  <td><i className="fa-brands fa-facebook"></i> Facebook</td>
  <td>(010) 2345 6789</td>
  <td>Completed</td>
  <td><i className="fa-solid fa-ellipsis-vertical"></i></td>
</tr>

<tr>
  <td><input type="checkbox" name="" id="" /></td>
  <td><img src={personone} alt="" /></td>
  <td>
    <p> Sara Khaled</p>
    <p>sara.khaled22@yahoo.com</p>
  </td>
  <td><i className="fa-brands fa-instagram"></i> Instagram</td>
  <td>(011) 9876 5432</td>
  <td>In Progress</td>
  <td><i className="fa-solid fa-ellipsis-vertical"></i></td>
</tr>

<tr>
  <td><input type="checkbox" name="" id="" /></td>
  <td><img src={persontwo} alt="" /></td>
  <td>
    <p> Karim Ali</p>
    <p>kareem.ali_tech@outlook.com</p>
  </td>
  <td><i className="fa-brands fa-linkedin"></i> LinkedIn</td>
  <td>(012) 1111 2222</td>
  <td>New Lead</td>
  <td><i className="fa-solid fa-ellipsis-vertical"></i></td>
</tr>

<tr>
  <td><input type="checkbox" name="" id="" /></td>
  <td><img src={personthree} alt="" /></td>
  <td>
    <p> Nour Ibrahiem</p>
    <p>nour.ibrahim99@gmail.com</p>
  </td>
  <td><i className="fa-brands fa-twitter"></i> Twitter</td>
  <td>(015) 5555 7777</td>
  <td>Not Interested</td>
  <td><i className="fa-solid fa-ellipsis-vertical"></i></td>
</tr>

<tr>
  <td><input type="checkbox" name="" id="" /></td>
  <td><img src={personone} alt="" /></td>
  <td>
    <p> Mahmoud Hassan</p>
    <p>mahmoud.hassan88@hotmail.com</p>
  </td>
  <td><i className="fa-brands fa-instagram"></i> Instagram</td>
  <td>(010) 8765 4321</td>
  <td>Contacted</td>
  <td><i className="fa-solid fa-ellipsis-vertical"></i></td>
</tr>

<tr>
  <td><input type="checkbox" name="" id="" /></td>
  <td><img src={personfive} alt="" /></td>
  <td>
    <p>Rana Mostafa </p>
    <p>rana.mostafa.pro@gmail.com</p>
  </td>
  <td><i className="fa-brands fa-facebook"></i> Facebook</td>
  <td>(011) 3333 4444</td>
  <td>Completed</td>
  <td><i className="fa-solid fa-ellipsis-vertical"></i></td>
</tr>
</tbody>

             </table>
                       </div>
                   </div>
        </div>
        </>
    )
}
export default Leads